@if (!preventNavigation) {
    <a dsTouchClick [href]="url" [msRemoveHref]="shouldRemoveHref">
        <ng-container *ngTemplateOutlet="betBuilderCardTemplate" />
    </a>
} @else {
    <ng-container *ngTemplateOutlet="betBuilderCardTemplate" />
}

<ng-template #betBuilderCardTemplate>
    @if (backgroundImage) {
        <img class="marquee-background-image" width="280" height="140" [ngSrc]="backgroundImage" [priority]="trackingPosition === 0" />
    }
    <div
        [ngClass]="{
            'card-special-image': backgroundImage && !tile.source?.isAutomatedMarquee,
            'card-special-image-automated': backgroundImage && tile.source?.isAutomatedMarquee,
        }">
        <div class="marquee-card-header card-promotional">
            @if (!tile.doNotShowAnyBadgeRibbon) {
                @if (!tile.hideBuildABetBadge) {
                    <div class="card-league">
                        <vn-icon name="sports-{{ tile.sportId }}" class="icon-alignment" size="11" />
                        <span class="special-card-league-text">{{
                            BadgeOverrideText ? BadgeOverrideText : sitecore.globalMessages.BetBuilderCardBadgeText
                        }}</span>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="eventTimer" />
                }
            }
        </div>
        <div class="card-special">
            @if (marketList) {
                @if (marketList.length === 1) {
                    <div class="card-market" [style.color]="tile.source?.textColor">{{ marketList }}</div>
                } @else if (marketList.length > 1) {
                    @for (market of marketList; track market) {
                        <span class="card-market-bullet">
                            <vn-icon
                                class="marquee-bullet"
                                [name]="isEpcotEnabled ? 'theme-open-bullet' : 'theme-radio-off'"
                                [size]="isEpcotEnabled ? '12' : '8'" />
                            <span class="card-market" [style.color]="tile.source?.textColor">{{ market }}</span>
                        </span>
                    }
                }
            }
        </div>
        <div class="card-special-price">
            <div class="card-special-price-prev event-info">
                <ng-container *ngTemplateOutlet="teamName" />
            </div>
            @if (isEpcotEnabled) {
                <div class="betbuilder-previous-odds">
                    @if (previousOdds) {
                        <span [style.color]="tile.source?.textColor">{{ sitecore.marquee.Was }} </span>
                        <span [style.color]="tile.source?.textColor">{{ previousOdds }}</span>
                    }
                </div>
            }
            <div
                class="card-special-odds-prev"
                [ngClass]="{ 'left-align-odds-button': tile.leftAlignOddsButton && tile.hideBuildABetBadge }"
                (click)="oddsClick($event)">
                <div class="card-option-group">
                    @if (tile.market && !tile.event.precreatedOptionGroups) {
                        <ms-betbuilder-pick
                            class="card-option-group"
                            [event]="tile.event"
                            [fixtureId]="tile.betBuilderFixtureId"
                            [betBuilderMarket]="tile.market"
                            [trackingSource]="trackingSource"
                            [trackingPosition]="trackingPosition"
                            [marqueeName]="tile.trackingDetail?.marqueeName"
                            [sitecoreTemplateId]="tile.trackingDetail?.sitecoreTemplateId"
                            [marqueeType]="tile.source?.marqueeType"
                            [isFromPortal]="tile?.isFromPortal"
                            [isAutomatedMarquee]="!!tile.source?.isAutomatedMarquee">
                            <ms-font-resizer
                                [defaultSize]="1"
                                [maxChars]="6"
                                [value]="tile.market.option.optionPrice.nativePrice | msNativePriceFormatter" />
                        </ms-betbuilder-pick>
                    }
                    @if (tile.event.precreatedOptionGroups && tile.eventOptionGroups) {
                        <ms-betbuilder-group-pick
                            class="card-option-group"
                            [event]="tile.event"
                            [eventOptionGroups]="tile.eventOptionGroups"
                            [betbuilderOptionGroup]="tile.event.precreatedOptionGroups[0]"
                            [class.disabled]="isSuspended">
                            @if (isSuspended) {
                                <div class="lock">
                                    <vn-icon name="theme-locked" size="11" />
                                </div>
                            }

                            <div class="option-value">
                                @if (!isSuspended) {
                                    <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="precreatedGroupOdds | msNativePriceFormatter" />
                                }
                            </div>
                        </ms-betbuilder-group-pick>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #eventTimer>
    <ms-event-timer
        class="card-event-date"
        [live]="tile.event.live"
        [start]="tile.event.startDate"
        [scoreboard]="tile.event.scoreboard"
        [style.color]="tile?.source?.textColor" />
</ng-template>

<ng-template #teamName>
    <div class="cs-text" [style.color]="tile.source?.textColor">{{ OverriddenTeamnames || teamNameWithIndicatorOverride }}</div>
</ng-template>
